module.exports = __webpack_public_path__ + "static/media/dice-5.d904d059.svg";